import { useCallback } from "react";
import { SEND_SORTING } from "api/api";
import { isProdDomain } from "logging/logging";

export const useSendSorting = () => {
  const sessionToken = sessionStorage.getItem("sessionToken");
  const loggingEnabled = isProdDomain()
  return useCallback(
    async (sortingName) => {
  if (!loggingEnabled || !sessionToken) return;

      try {
        const res = await fetch(SEND_SORTING, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionToken, sortingName }),
        });

        if (!res.ok) {
          console.error("Sorting send failed:", res.status);
        } else {
          console.log("✅ Sorting sent for:", sortingName);
        }
      } catch (err) {
        console.error("❌ Error sending sorting for:", sortingName, err);
      }
    },
    [loggingEnabled, sessionToken]
  );
};
